<template>
  <div
    class="modal fade show modal-dialog-centered modal-dialog-scrollable"
    style="padding-right: 12px; display: block;">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{isNew ? 'Добавление' : 'Редактирование'}}
            заметки для {{ client.fullname }}.
          </h5>

          <button type="button" class="close" @click="$emit('cancel')">
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="form-group">
            <label class="form-label" for="text">Текст</label>
            <textarea class="form-control" rows="3" v-model="text" id="text"></textarea>
          </div>
        </div>

        <div class="modal-footer justify-content-between">
          <button v-if="isNew" type="button" class="btn btn-primary text-nowrap" @click="submitForm">
            <i class="fas fa-plus"></i>
            Добавить заметку
          </button>
          <button v-else type="button" class="btn btn-primary text-nowrap" @click="submitForm">
            <i class="fas fa-edit"></i>
            Редактировать заметку
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ClientNoteForm',

  props: ['note', 'client'],

  data() {
    return {
      text: '',
      error: '',
    };
  },

  created() {
    if (!this.isNew) {
      this.text = this.note.text;
    }
  },

  computed: {
    isNew() {
      return typeof this.note === 'undefined';
    },
  },

  methods: {
    async submitForm() {
      this.$emit('submit', this.text);
    },
  },
};
</script>
